// extracted by mini-css-extract-plugin
module.exports = {"Page":"documents-list_Page__zY6RD"};